import React, { useRef } from "react";
import PropTypes from "prop-types";
import ReactSVG from "react-svg";

const Pagination = props => {
    const { t, page = 1, limit = 10, total = null, itemsRangeDisplay = 5, onChange, containerClassName } = props;
    const paginationItems = useRef(null);

    const getPageTotal = () => Math.ceil(total / limit);

    const getItems = () => {
        const items = [];
        const itemsRange = getItemsRange();
        for (let i = itemsRange.start; i <= itemsRange.end; i++) {
            const tempClassName = page === i ? "active" : "";
            items.push(
                <li key={i} onClick={() => handlePageChange(i)} className={tempClassName}>
                    {i}
                </li>
            );
        }
        return items;
    };

    const getItemsRange = () => {
        const pageTotal = getPageTotal();
        const range = itemsRangeDisplay - 1;
        const leftRange = Math.ceil(range / 2);
        const rightRange = range - leftRange;

        let startPage;
        let endPage;
        if (page <= leftRange) {
            startPage = 1;
            endPage = itemsRangeDisplay;
        } else if (page + rightRange > pageTotal) {
            startPage = pageTotal - range;
            endPage = pageTotal;
        } else {
            startPage = page - leftRange;
            endPage = page + rightRange;
        }
        return {
            start: startPage < 1 ? 1 : startPage,
            end: endPage > pageTotal ? pageTotal : endPage,
        };
    };

    const handlePageChange = newPage => {
        if (newPage === page || newPage > getPageTotal()) return;
        if (onChange) onChange({ page: newPage });
    };

    const getPrevPage = () => {
        const tempClassName = page === 1 ? "disabled" : "";
        return (
            <li className={tempClassName} onClick={() => handlePageChange(page - 1)}>
                <ReactSVG className="button-icon button-icon-size" src={`/data/svg/grid/pagination_arrow_prev.svg`} />
            </li>
        );
    };

    const getNextPage = () => {
        const tempClassName = page === getPageTotal() ? "disabled" : "";
        return (
            <li className={tempClassName} onClick={() => handlePageChange(page + 1)}>
                <ReactSVG className="button-icon button-icon-size" src={`/data/svg/grid/pagination_arrow_next.svg`} />
            </li>
        );
    };

    const getFirstPage = () => {
        const tempClassName = page === 1 ? "disabled" : "";
        return (
            <li className={tempClassName} onClick={() => handlePageChange(1)}>
                <ReactSVG className="button-icon button-icon-size" src={`/data/svg/grid/pagination_arrow_first.svg`} />
            </li>
        );
    };

    const getLastPage = () => {
        const pageTotal = getPageTotal();
        const tempClassName = page === pageTotal ? "disabled" : "";
        return (
            <li className={tempClassName} onClick={() => handlePageChange(pageTotal)}>
                <ReactSVG className="button-icon button-icon-size" src={`/data/svg/grid/pagination_arrow_last.svg`} />
            </li>
        );
    };

    const getInfo = () => {
        let start = page === 1 ? 0 : (page - 1) * limit;
        let end = total > limit ? start + limit : total;

        if (end > total) end = total;

        return (
            <div className="history-pagination-elements-count">
                {start} - {end} ({t("of")} <span className="total-count">{total}</span>)
            </div>
        );
    };

    if (!total) return null;

    let tempClassName = "pagination-container";
    if (containerClassName) tempClassName += ` ${containerClassName}`;

    return (
        <div className="history-pagination-container">
            <div className="history-pagination-pages-wrapper">
                <div className="history-pagination-pages">
                    <ul className="history-pagination-controls">
                        {getFirstPage()}
                        {getPrevPage()}
                    </ul>
                    <ul className="history-pagination-items" ref={paginationItems}>
                        {/* <div className="pagination-highlight" ref={paginationHighlight} /> */}
                        {getItems()}
                    </ul>
                    <ul className="history-pagination-controls">
                        {getNextPage()}
                        {getLastPage()}
                    </ul>
                </div>
            </div>
            <div className="history-pagination-total-actions">{getInfo()}</div>
        </div>
    );
};

Pagination.propTypes = {
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    containerClassName: PropTypes.string,
    itemsRangeDisplay: PropTypes.number,
};

export default Pagination;
